import { render, staticRenderFns } from "./TalentQualifications.vue?vue&type=template&id=3d768c46&scoped=true"
import script from "./TalentQualifications.vue?vue&type=script&lang=js"
export * from "./TalentQualifications.vue?vue&type=script&lang=js"
import style0 from "./TalentQualifications.vue?vue&type=style&index=0&id=3d768c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d768c46",
  null
  
)

export default component.exports